import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Dialog,IconButton,DialogContent,Divider,Button } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close';
import { ModalHeader } from 'reactstrap';
import {
    closeFilterPopUp,
    setFilterOption,getDashboardProspektFilter
} from 'actions'
import { isEmpty,isUndefined } from 'lodash';
import TextField from '@material-ui/core/TextField';
import ChipsList from './ChipsList'
import Laperut from './Inputs/Laperut'
import IntlMessages from 'util/IntlMessages';
import MinaBarnList from './Inputs/MinaBarnList' 
import MinaBarnUsersList from './Inputs/MinaBarnUsersList'

function mapStateToProps({accountsData,auth,DashBoard}) {
    const { currentKund,MyOfficeType,isIamChild,Userlista } = accountsData;
    const { authUser } = auth;
    const { DashboardProspektFilterOption,FilterDashbordProspektPopup } = DashBoard;
    return {
        currentKund,authUser,DashboardProspektFilterOption,FilterDashbordProspektPopup,MyOfficeType,isIamChild,Userlista
    };
}

function mapDispatchToProps(dispatch) {
    return {
        closeFilterPopUp:()=>dispatch(closeFilterPopUp()),
        setFilterOption:(Meta,FilterList)=>dispatch(setFilterOption(Meta,FilterList)),
        getDashboardProspektFilter:(Afid,userid,Filterstate)=>dispatch(getDashboardProspektFilter(Afid,userid,Filterstate)),
    };
}

class index extends Component {
    state={
        open:false,
        FilterDashbordProspektPopup:false,
        Filterstate:this.props.DashboardProspektFilterOption 
    }
    componentDidUpdate=()=>{
        if(this.state.FilterDashbordProspektPopup !== this.props.FilterDashbordProspektPopup &&  
            !isUndefined(this.props.FilterDashbordProspektPopup)
            ){
            this.setState({
                FilterDashbordProspektPopup:this.props.FilterDashbordProspektPopup,
                open:this.props.FilterDashbordProspektPopup,
                Filterstate:this.props.DashboardProspektFilterOption
            })
        }
       
    }
    handleClose=()=>{
        this.props.closeFilterPopUp();
     }
     FilterBythis=()=>{
        const Afid = this.props.authUser.user_Afid;
        const MainUser = this.props.authUser.user_id;
        this.props.setFilterOption("DashboardProspekt",this.state.Filterstate)
        this.props.getDashboardProspektFilter(Afid,MainUser,this.state.Filterstate)  
        this.handleClose()  
    }
    onChangeHandle=(Meta,Value,Meta1,Value1)=>{
        if(Meta === "Konton"){
            //remove 
            let Item1={
                Meta:Meta,
                Value:Value
            }
            let arr = isEmpty(this.state.Filterstate)?[]:this.state.Filterstate.filter(n=>{return n.Meta !==Meta})
            console.log(arr,"DDDA")
            arr = isEmpty(arr)?[]:arr.filter(n=>{return n.Meta !=="KontonUser"})
            console.log(arr,"DDDA")
            arr.push(Item1)
            this.setState({
                Filterstate:arr         
            })
        }
        else{
        if(!isUndefined(Meta1)){
            let Item1={
                Meta:Meta,
                Value:Value
            }
            let Item2={
                Meta:Meta1,
                Value:Value1
            }
            let arr = isEmpty(this.state.Filterstate)?[]:this.state.Filterstate.filter(n=>{return n.Meta !==Meta})
            arr.push(Item1)
            arr = arr.filter(n=>{return n.Meta !==Meta1})
            arr.push(Item2)

            this.setState({
                Filterstate:arr         
            })
        }else{
            let Item1={
                Meta:Meta,
                Value:Value
            }
            let arr = isEmpty(this.state.Filterstate)?[]:this.state.Filterstate.filter(n=>{return n.Meta !==Meta})
            arr.push(Item1)
            this.setState({
                Filterstate:arr  
            })
        }
        }
    }
    handleDeleteOptions=(item)=>{
        let OptionsList = this.state.Filterstate.filter(n=>{return n !==item})
        this.setState({
            ...this.state,
            Filterstate:OptionsList
        })
    }
    getPermission=()=>{
        let HasPermission = 0

        if(this.props.authUser.user_role <= 1){
            return 1
        }else{
            if(parseInt(this.props.authUser.user_isOfficeAdmin) === 1){
                if(parseInt(this.props.MyOfficeType) === 1){
                    //internt
                    return 1
                }else{
                    //Externt
                    return 2
                }                
            } else{
                return 0
            }
        }
    }
    render() {
        let HasPermission = this.getPermission()
        return (
            <Dialog onClose={this.handleClose} aria-labelledby="customized-dialog-title" 
            open={this.state.open} fullWidth={true}
            maxWidth={"md"} 
            disableBackdropClick={true} 
            >
                 <ModalHeader className="modal-box-header bg-primary text-white">
                 <IntlMessages id="Filter"/>
                    <IconButton className="text-white"
                    onClick={this.handleClose}>
                        <CloseIcon />
                    </IconButton>
                </ModalHeader>
                <DialogContent dividers>
                {
                    parseInt(this.props.isIamChild)===1?
                    <>
                     <div className="row" style={{ height: 'auto', paddingTop: '10px' }}>
                    <div className="col-12">
                        <MinaBarnList
                        handleChange={this.onChangeHandle}
                        />
                    </div>
                    </div>
                    {
                       !isEmpty(this.state.Filterstate.filter(item=>{return item.Meta === "Konton" && item.Value !=='-1'}))?
                       <div className="row" style={{ height: 'auto', paddingTop: '10px' }}>
                            <div className="col-12">
                            <MinaBarnUsersList
                            handleChange={this.onChangeHandle}
                            /> 
                            </div>
                        </div>
                       :"" 
                    }
                    </>
                    :
                    HasPermission !== 0?
                    <div className="row" style={{ height: '64px', paddingTop: '15px' }}>
                        <div className="col-12">
                    <TextField
                    variant="outlined"
                    fullWidth
                    label={<IntlMessages id="appKontoModule.Owner"/>}
                    size="small"
                    name="Ansvarig"
                    select
                    value={this.state.ansvarig}
                    SelectProps={{native: true,}}
                    InputLabelProps={{shrink: true,}}
                    onChange={(e)=>this.onChangeHandle("ansvarig",e.target.value)}
                    >
                    <option key={0} disabled value={0}><IntlMessages id="Choose"/></option>
                    {
                        HasPermission === 1?
                        <option key={-1} value={-1}><IntlMessages id="All"/></option>
                        :
                        <option key={-1} value={-2}><IntlMessages id="All"/></option>
                        
                    }
                    
                {        
                    HasPermission === 1?
                    !isEmpty(this.props.Userlista.filter(item=>{return !isEmpty(item.UserEmail)}))?
                    this.props.Userlista.filter(item=>{return !isEmpty(item.UserEmail)}).map((option) => (
                        <option key={option.id} value={option.id}>
                            {option.FirstName} {option.LastName}
                        </option>
                    )):""
                    :
                    !isEmpty(this.props.Userlista.filter(item=>{return !isEmpty(item.UserEmail)})
                    .filter(item=>{return item.OfficeId === this.props.authUser.user_OfficeId}))?
                    this.props.Userlista.filter(item=>{return !isEmpty(item.UserEmail)})
                    .filter(item=>{return item.OfficeId === this.props.authUser.user_OfficeId})
                    .map((option) => (
                        <option key={option.id} value={option.id}>
                            {option.FirstName} {option.LastName}
                        </option>
                    )) :""
                
                }
                </TextField>  
                </div>
                    </div>
                    :""
                }
                <div className="row" style={{ height: '64px', paddingTop: '15px' }}>
                 <div className="col-12"  style={{ height: 'auto', paddingTop: '10px' }}>
                    <Laperut
                    Meta={"Datum"}
                    Label={<IntlMessages id="Input.date"/>}
                    handleChange={this.onChangeHandle}
                    />
                </div>
            </div>
                <Divider/>
                <div>
                   <ChipsList
                   Chips={this.state.Filterstate}
                   handleDeleteOptions={this.handleDeleteOptions}
                   />{/**/}
                </div>
                </DialogContent>
                <Divider/>
                <div className="d-flex my-2 mr-2">
                <div className="ml-auto">
                <Button
                variant="contained"
                color="primary"
                className="jr-btn"
                onClick={this.FilterBythis}
                ><IntlMessages id="Filter.Button"/>
                </Button>
                </div>  
                </div>
            </Dialog>
        );
    }
}

export default connect(
    mapStateToProps,mapDispatchToProps
)(index);